// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KKNNxKX_YPBhyN {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  height: 96px;
  padding: 8px;
  overflow: hidden;
  border-radius: 8px;
  background-color: var(--ds-skeleton, #091e420f);
  background-position: center center;
  background-size: cover;
  color: var(--ds-text-subtle, #44546f);
  font-weight: 400;
  text-align: center;
}
.KKNNxKX_YPBhyN:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
}
.mA106Jyi4T0CT1 {
  height: 100%;
  min-height: 108px;
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.PGGjKGP50E5EwL {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardTile": `KKNNxKX_YPBhyN`,
	"newBoardTile": `mA106Jyi4T0CT1`,
	"boardDetails": `PGGjKGP50E5EwL`
};
export default ___CSS_LOADER_EXPORT___;
